"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var core_1 = require("@angular/core");
var type_configuration_service_1 = require("../../../../shared/services/api/type-configuration.service");
var root_category_provider_service_1 = require("../../../../shared/services/api/root-category-provider.service");
var Observable_1 = require("rxjs/Observable");
var router_1 = require("@angular/router");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var material_1 = require("@angular/material");
var form_resolution_service_1 = require("../../../../shared/services/api/form-resolution.service");
var idm_form_management_ui_1 = require("@synisys/idm-form-management-ui");
var root_category_summary_page_config_service_1 = require("../../../../shared/services/api/summary-pages/root-category-summary-page-config-service");
var summary_pages_navigation_prefix_1 = require("../../main-controls/summary-pages-navigation-prefix");
var base_portfolio_type_sub_type_filter_service_1 = require("../../../../shared/services/api/summary-pages/base-portfolio-type-sub-type-filter.service");
var portfolio_definitions_service_1 = require("../../../../shared/services/api/portfolio-definitions.service");
var operators_1 = require("rxjs/operators");
var dynamic_navigation_helper_1 = require("../utils/dynamic-navigation-helper");
var url_and_query_params_1 = require("../../../../shared/utils/url-and-query-params");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var type_subtype_select_dialog_component_1 = require("../../../../shared/dialogs/advanced/type-subtype-select/type-subtype-select-dialog.component");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var PortfolioHeaderHelperService = /** @class */ (function () {
    function PortfolioHeaderHelperService(dialog, router, route, kbService, typeResolverService, currentLanguageProvider, formResolutionService, formManagementService, rootCategorySummaryPageConfigService, rootCategoryProviderService, navigationPrefix, basePortfolioTypeSubTypeFilterService, portfolioDefinitionsService) {
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.kbService = kbService;
        this.typeResolverService = typeResolverService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.formResolutionService = formResolutionService;
        this.formManagementService = formManagementService;
        this.rootCategorySummaryPageConfigService = rootCategorySummaryPageConfigService;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.navigationPrefix = navigationPrefix;
        this.basePortfolioTypeSubTypeFilterService = basePortfolioTypeSubTypeFilterService;
        this.portfolioDefinitionsService = portfolioDefinitionsService;
    }
    PortfolioHeaderHelperService.prototype.loadCurrentRootCategory = function (categoryId) {
        return this.rootCategoryProviderService.getRootCategoryId(categoryId)
            .pipe(operators_1.publishReplay(1), operators_1.refCount());
    };
    // ToDo: reconsider logic of which portfolio to load when loading portfolios from summary / defined portfolios
    /**
     *
     * @param categoryId - category to load portfolio of
     * @param rootCategory - root of given category
     * @param rootEntityId - root entity id of given category
     */
    PortfolioHeaderHelperService.prototype.loadAvailablePortfolios = function (categoryId, rootCategory, rootEntityId) {
        var defaultPortfolio$ = this.loadDefaultPortfolio(categoryId, rootCategory, rootEntityId);
        var title$ = this.loadDefaultTitle(categoryId, rootCategory, rootEntityId);
        var definedPortfolios$ = this.loadDefinedPortfolios(categoryId, rootCategory, rootEntityId);
        return zip_1.zip(title$, defaultPortfolio$, definedPortfolios$).pipe(operators_1.map(function (_a) {
            var title = _a[0], defaultPortfolio = _a[1], definedPortfolios = _a[2];
            if (defaultPortfolio) {
                definedPortfolios.unshift(__assign({}, defaultPortfolio, { title: !title ? "nav.bar.workspace.base." + categoryId : title }));
            }
            return definedPortfolios;
        }));
    };
    PortfolioHeaderHelperService.prototype.createNewEntity = function (categoryId, rootCategoryId, rootEntityId) {
        var _this = this;
        var typedDialogConfig$ = this.constructCreateTypedDialogConfigs(categoryId, rootCategoryId, rootEntityId);
        return typedDialogConfig$.pipe(operators_1.switchMap(function (typedDialogConfig) {
            if (typedDialogConfig) {
                return _this.dialog.open(type_subtype_select_dialog_component_1.TypeSubtypeSelectDialogComponent, typedDialogConfig).afterClosed().pipe(operators_1.switchMap(function (selectedValues) {
                    if (selectedValues && selectedValues.type) {
                        return _this.navigateToSelectedTypeCreate(selectedValues.type, selectedValues.subType, categoryId, rootCategoryId || categoryId, rootEntityId);
                    }
                    return Observable_1.Observable.of(false);
                }));
            }
            else {
                return _this.navigateToFirstEditForm(categoryId, rootCategoryId, rootEntityId);
            }
        }));
    };
    // ToDo: select default portfolio in summary pages from list of default portfolios
    PortfolioHeaderHelperService.prototype.loadDefaultPortfolio = function (categoryId, rootCategoryId, rootEntityId) {
        if (!rootCategoryId || ((categoryId === rootCategoryId) && rootEntityId)) {
            return of_1.of(null);
        }
        return this.rootCategorySummaryPageConfigService
            .getPortfolioConfigByCategory(categoryId, rootCategoryId);
    };
    PortfolioHeaderHelperService.prototype.loadDefinedPortfolios = function (categoryId, rootCategoryId, rootEntityId) {
        if (!rootEntityId || (categoryId !== rootCategoryId)) {
            return this.portfolioDefinitionsService.loadPortfolioDefinitionsByCategory(categoryId);
        }
        return of_1.of([]);
    };
    PortfolioHeaderHelperService.prototype.loadDefaultTitle = function (categoryId, rootCategoryId, rootEntityId) {
        if (rootEntityId) {
            return this.rootCategorySummaryPageConfigService.getCardConfigByCategory(categoryId, rootCategoryId)
                .pipe(operators_1.map(function (config) { return config ? config.title : undefined; }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return of_1.of(null);
    };
    PortfolioHeaderHelperService.prototype.constructCreateTypedDialogConfigs = function (categoryId, rootCategoryId, rootEntityId) {
        var _this = this;
        var entityTypeConfigs$ = this.typeResolverService.getTypedCategoryProperties(categoryId);
        var metaCategory$ = this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(categoryId));
        var categoryName = categoryId.toLowerCase();
        return zip_1.zip(entityTypeConfigs$, metaCategory$).pipe(operators_1.switchMap(function (_a) {
            var typeConfig = _a[0], metaCategory = _a[1];
            if (typeConfig) {
                var filteringResult$ = _this.getFilteredTypesSubTypes(categoryId, rootCategoryId, rootEntityId, typeConfig);
                return filteringResult$.pipe(operators_1.map(function (filteringResult) {
                    return type_subtype_select_dialog_component_1.TypeSubtypeSelectDialogComponent.getConfig(typeConfig, filteringResult.acceptableTypeIds, filteringResult.acceptableSubTypeIds, metaCategory.getDisplayNameMultilingual(), metaCategory.getDisplayNameMsgId(), "ejustice_" + categoryName + "_type", "ejustice_" + categoryName + "_subtype");
                }));
            }
            else {
                return of_1.of(null);
            }
        }));
    };
    PortfolioHeaderHelperService.prototype.navigateToSelectedTypeCreate = function (type, subType, categoryId, mainCategoryId, mainEntityId) {
        var _this = this;
        var typeId = type.getId();
        var subTypeId = subType ? subType.getId() : null;
        return this.formResolutionService.getFormProperties(categoryId, typeId, subTypeId).pipe(operators_1.switchMap(function (formData) {
            var params = new Map()
                .set(url_and_query_params_1.UrlAndQueryParams.typeId, typeId)
                .set(url_and_query_params_1.UrlAndQueryParams.subTypeId, subTypeId);
            return dynamic_navigation_helper_1.navigateToCreateForm(_this.navigationPrefix, mainCategoryId, mainEntityId, categoryId, formData.editFormName, formData.editFormId, _this.route, _this.router, params);
        }));
    };
    PortfolioHeaderHelperService.prototype.navigateToFirstEditForm = function (categoryId, rootCategoryId, rootEntityId) {
        var _this = this;
        return this.formManagementService.loadFormsByCategoryAndType(categoryId, idm_dynamic_layout_interpreter_1.FormType.EDIT).pipe(operators_1.switchMap(function (forms) {
            if (forms.length) {
                return dynamic_navigation_helper_1.navigateToCreateForm(_this.navigationPrefix, rootCategoryId, rootEntityId, categoryId, forms[0].systemName, forms[0].id, _this.route, _this.router);
            }
            throw new Error('Form does not exist');
        }));
    };
    PortfolioHeaderHelperService.prototype.getFilteredTypesSubTypes = function (categoryId, rootCategoryId, rootEntityId, typeConfig) {
        if (this.basePortfolioTypeSubTypeFilterService) {
            return this.basePortfolioTypeSubTypeFilterService.filter(rootCategoryId, rootEntityId, categoryId, typeConfig);
        }
        return Observable_1.Observable.of({});
    };
    PortfolioHeaderHelperService = __decorate([
        core_1.Injectable(),
        __param(10, core_1.Optional()), __param(10, core_1.Inject(summary_pages_navigation_prefix_1.SUMMARY_PAGES_NAVIGATION_PREFIX)),
        __param(11, core_1.Optional()),
        __param(12, core_1.Optional()),
        __metadata("design:paramtypes", [material_1.MatDialog,
            router_1.Router,
            router_1.ActivatedRoute,
            idm_kb_service_client_js_1.KbService,
            type_configuration_service_1.TypeConfigurationService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            form_resolution_service_1.FormResolutionService,
            idm_form_management_ui_1.FormManagementService,
            root_category_summary_page_config_service_1.RootCategorySummaryPageConfigService,
            root_category_provider_service_1.RootCategoryProviderService, String, base_portfolio_type_sub_type_filter_service_1.BasePortfolioTypeSubTypeFilterService,
            portfolio_definitions_service_1.PortfolioDefinitionsService])
    ], PortfolioHeaderHelperService);
    return PortfolioHeaderHelperService;
}());
exports.PortfolioHeaderHelperService = PortfolioHeaderHelperService;
//# sourceMappingURL=portfolio-header-helper.service.js.map